import eventDictionary from './event_dictionary.json';
import {getSanitizedJsonAndParse} from '../utils/get_sanitized_json_and_parse';

const setNullPropertiesMap = eventPropertyKeys =>
  eventPropertyKeys.reduce((nullMap, PropertyKey) => {
    nullMap[PropertyKey] = null;

    return nullMap;
  }, {});

const getGroupPropertiesKeysDefaultFromName = eventName => {
  const eventsByName = eventDictionary.events[eventName];

  if (!eventsByName || !eventsByName.properties) {
    return {};
  }

  return setNullPropertiesMap(Object.keys(eventsByName.properties));
};

const memoizedEventDefaultsByName = () => {
  const cache = {};

  return name => {
    if (!cache[name]) {
      cache[name] = getGroupPropertiesKeysDefaultFromName(name);
    }

    return cache[name];
  };
};

export const eventPropertiesFromServerRequest = getSanitizedJsonAndParse('ez-page-properties');

export const getEventPropertiesDefaultsFromName = memoizedEventDefaultsByName();
